import { ButtonLink } from "design-system/atoms/Button"

import { Outlet } from "@tanstack/react-router"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useAmphoraIntegrationQuery } from "modules/settings/hooks/amphora/useAmphoraIntegrationQuery"
import { useTranslation } from "react-i18next"
import { Communications } from "./components/Communications"
import { FindOrder } from "./components/findOrder"

export const AmphoraIntegration = () => {
  const { t } = useTranslation()
  const { data } = useAmphoraIntegrationQuery()
  const hasConfiguration = data?.accessId
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  return (
    <div className="flex flex-col gap-8">
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4 md:p-6">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.amphora.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.amphora.integrationCard.descriptionDone")
                : t("settings.integrations.amphora.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.amphora.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/amphora/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/amphora/connect"}>
                {t("settings.integrations.amphora.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>
      {hasConfiguration ? <Communications /> : null}
      <Section title={t("settings.integrations.bigblue.tools")}>
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
          <FindOrder isDisabled={!hasConfiguration} disabledReason={disabledReason} />
        </div>
      </Section>
      <Outlet />
    </div>
  )
}
